module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C2N9lJ/tc-custom/9781788854948.jpg?1728259609496",
      "alt": "This image is the cover for the book Alternatives to Valium"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alternatives to Valium\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“A few years ago, I asked Tom Petty how his songs had been influenced by his life. As a rule, songwriters aren’t keen on unpicking their work, and Petty was no exception. He didn’t want to get into specifics. ‘Life is so difficult,’ he said. ‘And easy. It’s just a chain of spontaneous events.’”  Alastair McKay’s own life was inspired and informed by music, so his book takes the form of an album, with two distinct sides. The first side is about childhood, and the struggle to find a voice. The second side is about interviews, and learning how to listen.  An exceptionally shy boy, Alastair gradually found his voice through the punk explosion: the ethos that ‘anyone could do it’ prompted him to start writing, largely because it was easier than talking. From these hesitant beginnings, and his own failed attempts at musicianship, he would go on to a successful career in journalism: sharing a limousine with Kate Moss, meeting Iggy Pop at the Chateau Marmont, being led astray by Tilda Swinton and many, many other encounters.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alastair McKay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alastair McKay is a journalist living in London. He grew up in North Berwick, Aberdeen and Edinburgh. He currently writes for the Evening Standard in London, and Uncut magazine. He has worked for The Scotsman, Scotland on Sunday, The Sunday Times, The Guardian, Black Book, Out, Blah Blah Blah and The Independent. He lives in London.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Polygon\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0